<!--<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">-->
<div class="modal-content">
  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
    <div class="modal-header">
      <h5 class="modal-title" id="stationAddLabel" i18n="@@CreateChargingStationHeader">Neuer Hersteller</h5>
      <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
    </div>
    <div class="modal-body">
      <app-create-manufacturer (newEntityEvent)="newEntityEvent($event)"></app-create-manufacturer>
    </div>
    <div class="modal-footer">

      <a class="btn btn-yellow" id="cancel" data-bs-toggle="modal" role="button" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Abbrechen</a>
      <button type="submit" id="create_manufacturer" class="btn btn-primary" [disabled]="!formService.form.valid" i18n="@@CreateChargingStationButton">Hersteller anlegen</button>
    </div>
  </form>

</div>
<!--</div>-->



